const INITIAL_ARR_INDEX = 0;

/**
 * Проверяем, есть ли элемент в массиве
 * Аналог inArray в jQuery
 *
 * @param {*} value - что ищем
 * @param {*} array - массив
 * @param {*} fromIndex - индекс, с которого начинаем поиск
 * @returns
 */
function inArray(value, arr, fromIndex = INITIAL_ARR_INDEX) {
  const arrSliced = arr.slice(fromIndex);

  return arrSliced.indexOf(value);
}

export default inArray;
